import { FilterField } from "kontrolEdge/helpers/advancedFilters";
import { keListTagFilterHaystack } from "kontrolEdge/components/Shared/mapKeListResourceTags";
import { resolveServiceStatusTag } from "kontrolEdge/helpers/serviceStatusTag";
import { CarrierBridge, carrierBridgeIdHeader } from "./CarrierBridgeData";

function makeBaseCarrierBridgeFields(): FilterField<CarrierBridge>[] {
  return [
    {
      label: carrierBridgeIdHeader,
      key: "carrierbridgeid",
      accessor: (r) => r.serviceId,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      // Searches the word the badge shows ("Active", "Warning"…), not the raw status.
      label: "Status",
      key: "status",
      accessor: (r) => resolveServiceStatusTag(r.serviceStatus).label,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Tags",
      key: "tags",
      accessor: (r) => keListTagFilterHaystack(r),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Carrier",
      key: "carrier",
      accessor: (r) => r.carrierName,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Port",
      key: "port",
      accessor: (r) => `${r.portSubid} ${r.siteName}`,
      type: "string",
      inFreeText: true,
    },
    {
      label: "VLAN",
      key: "vlan",
      accessor: (r) => r.vlanLabel,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Bandwidth",
      key: "bandwidth",
      accessor: (r) => r.mbps,
      type: "number",
    },
    {
      label: "Term",
      key: "term",
      accessor: (r) => r.term,
      type: "string",
    },
    {
      label: "Renew Date",
      key: "renewdate",
      accessor: (r) => r.renewDate,
      type: "string",
    },
  ];
}

export function makeCarrierBridgeFields(
  isViewingAllCustomers: boolean
): FilterField<CarrierBridge>[] {
  const fields = makeBaseCarrierBridgeFields();
  if (isViewingAllCustomers) {
    fields.splice(0, 0, {
      label: "Customer",
      key: "customer",
      accessor: (r) =>
        [r.customer?.name ?? "", r.customer?.chargebeeCustomerId ?? ""]
          .filter(Boolean)
          .join(" "),
      type: "string",
      inFreeText: true,
    });
  }
  return fields;
}
